import { render, staticRenderFns } from "./Userdetails.vue?vue&type=template&id=1fe0de5e&"
import script from "./Userdetails.vue?vue&type=script&lang=js&"
export * from "./Userdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports